var map = {
	"./Detetive_Nini": 165,
	"./Detetive_Nini.png": 165,
	"./Gatilho-botao": 166,
	"./Gatilho-botao.svg": 166,
	"./about": 167,
	"./about.png": 167,
	"./abranda": 168,
	"./abranda.png": 168,
	"./age": 169,
	"./age.png": 169,
	"./ana_nervosa": 170,
	"./ana_nervosa.png": 170,
	"./ana_sobre": 171,
	"./ana_sobre.png": 171,
	"./ana_triste": 172,
	"./ana_triste.png": 172,
	"./aranha": 173,
	"./aranha.png": 173,
	"./audio": 174,
	"./audio.svg": 174,
	"./avatar": 175,
	"./avatar.png": 175,
	"./barco": 176,
	"./barco.png": 176,
	"./blobs/blob-brown": 177,
	"./blobs/blob-brown.svg": 177,
	"./blobs/blob-green-light": 178,
	"./blobs/blob-green-light.svg": 178,
	"./blobs/blob-orange": 179,
	"./blobs/blob-orange.svg": 179,
	"./blobs/blob-pink": 180,
	"./blobs/blob-pink.svg": 180,
	"./blobs/blob-purple": 181,
	"./blobs/blob-purple.svg": 181,
	"./blobs/blob-red": 182,
	"./blobs/blob-red.svg": 182,
	"./boca": 183,
	"./boca.png": 183,
	"./caixa": 184,
	"./caixa.svg": 184,
	"./carro": 185,
	"./carro.png": 185,
	"./certo": 186,
	"./certo.svg": 186,
	"./cesta": 187,
	"./cesta.png": 187,
	"./cesta2": 188,
	"./cesta2.png": 188,
	"./comportamento": 189,
	"./comportamento.svg": 189,
	"./contar1": 190,
	"./contar1.png": 190,
	"./contar2": 191,
	"./contar2.png": 191,
	"./contar3": 192,
	"./contar3.png": 192,
	"./contar4": 193,
	"./contar4.png": 193,
	"./desvantagens": 194,
	"./desvantagens.svg": 194,
	"./diploma": 195,
	"./diploma.png": 195,
	"./edgar_sobre": 196,
	"./edgar_sobre.png": 196,
	"./edgar_zangado": 197,
	"./edgar_zangado.png": 197,
	"./emotions/sebastiao-anger": 198,
	"./emotions/sebastiao-anger.svg": 198,
	"./emotions/sebastiao-fear": 199,
	"./emotions/sebastiao-fear.svg": 199,
	"./emotions/sebastiao-joy": 200,
	"./emotions/sebastiao-joy.svg": 200,
	"./emotions/sebastiao-sadness": 201,
	"./emotions/sebastiao-sadness.svg": 201,
	"./emotions/sebastiao-shame": 202,
	"./emotions/sebastiao-shame.svg": 202,
	"./entidades_organizadoras/cineicc": 203,
	"./entidades_organizadoras/cineicc.svg": 203,
	"./entidades_organizadoras/fct": 204,
	"./entidades_organizadoras/fct.svg": 204,
	"./entidades_organizadoras/fpceuc": 205,
	"./entidades_organizadoras/fpceuc.svg": 205,
	"./entidades_organizadoras/fpul": 206,
	"./entidades_organizadoras/fpul.svg": 206,
	"./entidades_organizadoras/uniao_europeia": 207,
	"./entidades_organizadoras/uniao_europeia.svg": 207,
	"./escadotes/escadote_10": 208,
	"./escadotes/escadote_10.png": 208,
	"./escadotes/escadote_3": 209,
	"./escadotes/escadote_3.png": 209,
	"./escadotes/escadote_4": 210,
	"./escadotes/escadote_4.png": 210,
	"./escadotes/escadote_5": 211,
	"./escadotes/escadote_5.png": 211,
	"./escadotes/escadote_6": 212,
	"./escadotes/escadote_6.png": 212,
	"./escadotes/escadote_7": 213,
	"./escadotes/escadote_7.png": 213,
	"./escadotes/escadote_8": 214,
	"./escadotes/escadote_8.png": 214,
	"./escadotes/escadote_9": 215,
	"./escadotes/escadote_9.png": 215,
	"./group": 216,
	"./group.svg": 216,
	"./lesson_5/ana_adivinhadora": 217,
	"./lesson_5/ana_adivinhadora.png": 217,
	"./lesson_5/animais": 218,
	"./lesson_5/animais.jpg": 218,
	"./lesson_5/caras": 219,
	"./lesson_5/caras.jpg": 219,
	"./lesson_5/edgar_exagerado": 220,
	"./lesson_5/edgar_exagerado.png": 220,
	"./lesson_5/nini_negativa": 221,
	"./lesson_5/nini_negativa.png": 221,
	"./lesson_5/sebastiao_pensamento": 222,
	"./lesson_5/sebastiao_pensamento.png": 222,
	"./lesson_5/sebastiao_saltitao": 157,
	"./lesson_5/sebastiao_saltitao.png": 157,
	"./lesson_5/sebastiao_saltitao.svg": 502,
	"./lesson_5/sebastiao_saltitao_large": 223,
	"./lesson_5/sebastiao_saltitao_large.png": 223,
	"./lesson_5/sebastiao_triste": 224,
	"./lesson_5/sebastiao_triste.png": 224,
	"./lesson_5/sebastiao_varios_pensamentos": 158,
	"./lesson_5/sebastiao_varios_pensamentos.png": 158,
	"./lesson_5/sebastiao_varios_pensamentos.svg": 503,
	"./lesson_7/nini_com_sucesso": 225,
	"./lesson_7/nini_com_sucesso.png": 225,
	"./lesson_7/nini_sem_sucesso": 226,
	"./lesson_7/nini_sem_sucesso.png": 226,
	"./lesson_7/sebastiao_barco": 227,
	"./lesson_7/sebastiao_barco.png": 227,
	"./lesson_7/sebastiao_carro": 228,
	"./lesson_7/sebastiao_carro.png": 228,
	"./lesson_7/sebastiao_cesta": 229,
	"./lesson_7/sebastiao_cesta.png": 229,
	"./lesson_7/sebastiao_com_sucesso": 230,
	"./lesson_7/sebastiao_com_sucesso.png": 230,
	"./lesson_7/sebastiao_oculos_mergulho": 231,
	"./lesson_7/sebastiao_oculos_mergulho.png": 231,
	"./lesson_7/sebastiao_patins": 232,
	"./lesson_7/sebastiao_patins.png": 232,
	"./lesson_7/sebastiao_ponte": 233,
	"./lesson_7/sebastiao_ponte.png": 233,
	"./lesson_7/sebastiao_sem_sucesso": 234,
	"./lesson_7/sebastiao_sem_sucesso.png": 234,
	"./lesson_9/grupo": 235,
	"./lesson_9/grupo.png": 235,
	"./lesson_9/nini_caderno": 236,
	"./lesson_9/nini_caderno.png": 236,
	"./lesson_9/pais": 237,
	"./lesson_9/pais.png": 237,
	"./lesson_9/sebastiao_urso": 238,
	"./lesson_9/sebastiao_urso.png": 238,
	"./logo": 239,
	"./logo-icon": 240,
	"./logo-icon.png": 240,
	"./logo.png": 239,
	"./mao": 241,
	"./mao.png": 241,
	"./nariz": 242,
	"./nariz.png": 242,
	"./nini_criancas": 243,
	"./nini_criancas.png": 243,
	"./nini_escada": 244,
	"./nini_escada.png": 244,
	"./nini_landing": 245,
	"./nini_landing.png": 245,
	"./nini_sobre": 246,
	"./nini_sobre.png": 246,
	"./nuvem": 247,
	"./nuvem.svg": 247,
	"./oculos_mergulho": 248,
	"./oculos_mergulho.png": 248,
	"./olho": 249,
	"./olho.png": 249,
	"./online": 250,
	"./online.svg": 250,
	"./online_zoom": 251,
	"./online_zoom.svg": 251,
	"./orelha": 252,
	"./orelha.png": 252,
	"./pais": 253,
	"./pais.png": 253,
	"./para": 254,
	"./para.png": 254,
	"./patins": 255,
	"./patins.png": 255,
	"./pause": 256,
	"./pause.png": 256,
	"./pensamentos": 257,
	"./pensamentos.svg": 257,
	"./play": 258,
	"./play.svg": 258,
	"./ponte": 259,
	"./ponte.png": 259,
	"./ponto_de_interrogacao": 260,
	"./ponto_de_interrogacao.svg": 260,
	"./presential": 261,
	"./presential.svg": 261,
	"./puzzle/puzzle_1": 262,
	"./puzzle/puzzle_1.png": 262,
	"./puzzle/puzzle_10": 263,
	"./puzzle/puzzle_10.png": 263,
	"./puzzle/puzzle_100": 264,
	"./puzzle/puzzle_100.png": 264,
	"./puzzle/puzzle_101": 265,
	"./puzzle/puzzle_101.png": 265,
	"./puzzle/puzzle_102": 266,
	"./puzzle/puzzle_102.png": 266,
	"./puzzle/puzzle_103": 267,
	"./puzzle/puzzle_103.png": 267,
	"./puzzle/puzzle_104": 268,
	"./puzzle/puzzle_104.png": 268,
	"./puzzle/puzzle_105": 269,
	"./puzzle/puzzle_105.png": 269,
	"./puzzle/puzzle_106": 270,
	"./puzzle/puzzle_106.png": 270,
	"./puzzle/puzzle_107": 271,
	"./puzzle/puzzle_107.png": 271,
	"./puzzle/puzzle_108": 272,
	"./puzzle/puzzle_108.png": 272,
	"./puzzle/puzzle_109": 273,
	"./puzzle/puzzle_109.png": 273,
	"./puzzle/puzzle_11": 274,
	"./puzzle/puzzle_11.png": 274,
	"./puzzle/puzzle_110": 275,
	"./puzzle/puzzle_110.png": 275,
	"./puzzle/puzzle_111": 276,
	"./puzzle/puzzle_111.png": 276,
	"./puzzle/puzzle_112": 277,
	"./puzzle/puzzle_112.png": 277,
	"./puzzle/puzzle_113": 278,
	"./puzzle/puzzle_113.png": 278,
	"./puzzle/puzzle_114": 279,
	"./puzzle/puzzle_114.png": 279,
	"./puzzle/puzzle_115": 280,
	"./puzzle/puzzle_115.png": 280,
	"./puzzle/puzzle_116": 281,
	"./puzzle/puzzle_116.png": 281,
	"./puzzle/puzzle_117": 282,
	"./puzzle/puzzle_117.png": 282,
	"./puzzle/puzzle_118": 283,
	"./puzzle/puzzle_118.png": 283,
	"./puzzle/puzzle_119": 284,
	"./puzzle/puzzle_119.png": 284,
	"./puzzle/puzzle_12": 285,
	"./puzzle/puzzle_12.png": 285,
	"./puzzle/puzzle_120": 286,
	"./puzzle/puzzle_120.png": 286,
	"./puzzle/puzzle_121": 287,
	"./puzzle/puzzle_121.png": 287,
	"./puzzle/puzzle_122": 288,
	"./puzzle/puzzle_122.png": 288,
	"./puzzle/puzzle_123": 289,
	"./puzzle/puzzle_123.png": 289,
	"./puzzle/puzzle_124": 290,
	"./puzzle/puzzle_124.png": 290,
	"./puzzle/puzzle_125": 291,
	"./puzzle/puzzle_125.png": 291,
	"./puzzle/puzzle_126": 292,
	"./puzzle/puzzle_126.png": 292,
	"./puzzle/puzzle_13": 293,
	"./puzzle/puzzle_13.png": 293,
	"./puzzle/puzzle_14": 294,
	"./puzzle/puzzle_14.png": 294,
	"./puzzle/puzzle_15": 295,
	"./puzzle/puzzle_15.png": 295,
	"./puzzle/puzzle_16": 296,
	"./puzzle/puzzle_16.png": 296,
	"./puzzle/puzzle_17": 297,
	"./puzzle/puzzle_17.png": 297,
	"./puzzle/puzzle_18": 298,
	"./puzzle/puzzle_18.png": 298,
	"./puzzle/puzzle_19": 299,
	"./puzzle/puzzle_19.png": 299,
	"./puzzle/puzzle_2": 300,
	"./puzzle/puzzle_2.png": 300,
	"./puzzle/puzzle_20": 301,
	"./puzzle/puzzle_20.png": 301,
	"./puzzle/puzzle_21": 302,
	"./puzzle/puzzle_21.png": 302,
	"./puzzle/puzzle_22": 303,
	"./puzzle/puzzle_22.png": 303,
	"./puzzle/puzzle_23": 304,
	"./puzzle/puzzle_23.png": 304,
	"./puzzle/puzzle_24": 305,
	"./puzzle/puzzle_24.png": 305,
	"./puzzle/puzzle_25": 306,
	"./puzzle/puzzle_25.png": 306,
	"./puzzle/puzzle_26": 307,
	"./puzzle/puzzle_26.png": 307,
	"./puzzle/puzzle_27": 308,
	"./puzzle/puzzle_27.png": 308,
	"./puzzle/puzzle_28": 309,
	"./puzzle/puzzle_28.png": 309,
	"./puzzle/puzzle_29": 310,
	"./puzzle/puzzle_29.png": 310,
	"./puzzle/puzzle_3": 311,
	"./puzzle/puzzle_3.png": 311,
	"./puzzle/puzzle_30": 312,
	"./puzzle/puzzle_30.png": 312,
	"./puzzle/puzzle_31": 313,
	"./puzzle/puzzle_31.png": 313,
	"./puzzle/puzzle_32": 314,
	"./puzzle/puzzle_32.png": 314,
	"./puzzle/puzzle_33": 315,
	"./puzzle/puzzle_33.png": 315,
	"./puzzle/puzzle_34": 316,
	"./puzzle/puzzle_34.png": 316,
	"./puzzle/puzzle_35": 317,
	"./puzzle/puzzle_35.png": 317,
	"./puzzle/puzzle_36": 318,
	"./puzzle/puzzle_36.png": 318,
	"./puzzle/puzzle_37": 319,
	"./puzzle/puzzle_37.png": 319,
	"./puzzle/puzzle_38": 320,
	"./puzzle/puzzle_38.png": 320,
	"./puzzle/puzzle_39": 321,
	"./puzzle/puzzle_39.png": 321,
	"./puzzle/puzzle_4": 322,
	"./puzzle/puzzle_4.png": 322,
	"./puzzle/puzzle_40": 323,
	"./puzzle/puzzle_40.png": 323,
	"./puzzle/puzzle_41": 324,
	"./puzzle/puzzle_41.png": 324,
	"./puzzle/puzzle_42": 325,
	"./puzzle/puzzle_42.png": 325,
	"./puzzle/puzzle_43": 326,
	"./puzzle/puzzle_43.png": 326,
	"./puzzle/puzzle_44": 327,
	"./puzzle/puzzle_44.png": 327,
	"./puzzle/puzzle_45": 328,
	"./puzzle/puzzle_45.png": 328,
	"./puzzle/puzzle_46": 329,
	"./puzzle/puzzle_46.png": 329,
	"./puzzle/puzzle_47": 330,
	"./puzzle/puzzle_47.png": 330,
	"./puzzle/puzzle_48": 331,
	"./puzzle/puzzle_48.png": 331,
	"./puzzle/puzzle_49": 332,
	"./puzzle/puzzle_49.png": 332,
	"./puzzle/puzzle_5": 333,
	"./puzzle/puzzle_5.png": 333,
	"./puzzle/puzzle_50": 334,
	"./puzzle/puzzle_50.png": 334,
	"./puzzle/puzzle_51": 335,
	"./puzzle/puzzle_51.png": 335,
	"./puzzle/puzzle_52": 336,
	"./puzzle/puzzle_52.png": 336,
	"./puzzle/puzzle_53": 337,
	"./puzzle/puzzle_53.png": 337,
	"./puzzle/puzzle_54": 338,
	"./puzzle/puzzle_54.png": 338,
	"./puzzle/puzzle_55": 339,
	"./puzzle/puzzle_55.png": 339,
	"./puzzle/puzzle_56": 340,
	"./puzzle/puzzle_56.png": 340,
	"./puzzle/puzzle_57": 341,
	"./puzzle/puzzle_57.png": 341,
	"./puzzle/puzzle_58": 342,
	"./puzzle/puzzle_58.png": 342,
	"./puzzle/puzzle_59": 343,
	"./puzzle/puzzle_59.png": 343,
	"./puzzle/puzzle_6": 344,
	"./puzzle/puzzle_6.png": 344,
	"./puzzle/puzzle_60": 345,
	"./puzzle/puzzle_60.png": 345,
	"./puzzle/puzzle_61": 346,
	"./puzzle/puzzle_61.png": 346,
	"./puzzle/puzzle_62": 347,
	"./puzzle/puzzle_62.png": 347,
	"./puzzle/puzzle_63": 348,
	"./puzzle/puzzle_63.png": 348,
	"./puzzle/puzzle_64": 349,
	"./puzzle/puzzle_64.png": 349,
	"./puzzle/puzzle_65": 350,
	"./puzzle/puzzle_65.png": 350,
	"./puzzle/puzzle_66": 351,
	"./puzzle/puzzle_66.png": 351,
	"./puzzle/puzzle_67": 352,
	"./puzzle/puzzle_67.png": 352,
	"./puzzle/puzzle_68": 353,
	"./puzzle/puzzle_68.png": 353,
	"./puzzle/puzzle_69": 354,
	"./puzzle/puzzle_69.png": 354,
	"./puzzle/puzzle_7": 355,
	"./puzzle/puzzle_7.png": 355,
	"./puzzle/puzzle_70": 356,
	"./puzzle/puzzle_70.png": 356,
	"./puzzle/puzzle_71": 357,
	"./puzzle/puzzle_71.png": 357,
	"./puzzle/puzzle_72": 358,
	"./puzzle/puzzle_72.png": 358,
	"./puzzle/puzzle_73": 359,
	"./puzzle/puzzle_73.png": 359,
	"./puzzle/puzzle_74": 360,
	"./puzzle/puzzle_74.png": 360,
	"./puzzle/puzzle_75": 361,
	"./puzzle/puzzle_75.png": 361,
	"./puzzle/puzzle_76": 362,
	"./puzzle/puzzle_76.png": 362,
	"./puzzle/puzzle_77": 363,
	"./puzzle/puzzle_77.png": 363,
	"./puzzle/puzzle_78": 364,
	"./puzzle/puzzle_78.png": 364,
	"./puzzle/puzzle_79": 365,
	"./puzzle/puzzle_79.png": 365,
	"./puzzle/puzzle_8": 366,
	"./puzzle/puzzle_8.png": 366,
	"./puzzle/puzzle_80": 367,
	"./puzzle/puzzle_80.png": 367,
	"./puzzle/puzzle_81": 368,
	"./puzzle/puzzle_81.png": 368,
	"./puzzle/puzzle_82": 369,
	"./puzzle/puzzle_82.png": 369,
	"./puzzle/puzzle_83": 370,
	"./puzzle/puzzle_83.png": 370,
	"./puzzle/puzzle_84": 371,
	"./puzzle/puzzle_84.png": 371,
	"./puzzle/puzzle_85": 372,
	"./puzzle/puzzle_85.png": 372,
	"./puzzle/puzzle_86": 373,
	"./puzzle/puzzle_86.png": 373,
	"./puzzle/puzzle_87": 374,
	"./puzzle/puzzle_87.png": 374,
	"./puzzle/puzzle_88": 375,
	"./puzzle/puzzle_88.png": 375,
	"./puzzle/puzzle_89": 376,
	"./puzzle/puzzle_89.png": 376,
	"./puzzle/puzzle_9": 377,
	"./puzzle/puzzle_9.png": 377,
	"./puzzle/puzzle_90": 378,
	"./puzzle/puzzle_90.png": 378,
	"./puzzle/puzzle_91": 379,
	"./puzzle/puzzle_91.png": 379,
	"./puzzle/puzzle_92": 380,
	"./puzzle/puzzle_92.png": 380,
	"./puzzle/puzzle_93": 381,
	"./puzzle/puzzle_93.png": 381,
	"./puzzle/puzzle_94": 382,
	"./puzzle/puzzle_94.png": 382,
	"./puzzle/puzzle_95": 383,
	"./puzzle/puzzle_95.png": 383,
	"./puzzle/puzzle_96": 384,
	"./puzzle/puzzle_96.png": 384,
	"./puzzle/puzzle_97": 385,
	"./puzzle/puzzle_97.png": 385,
	"./puzzle/puzzle_98": 386,
	"./puzzle/puzzle_98.png": 386,
	"./puzzle/puzzle_99": 387,
	"./puzzle/puzzle_99.png": 387,
	"./relogio": 388,
	"./relogio.png": 388,
	"./replay": 159,
	"./replay.png": 159,
	"./replay.svg": 504,
	"./sebastiao_a_pensar": 389,
	"./sebastiao_a_pensar.png": 389,
	"./sebastiao_nervoso": 390,
	"./sebastiao_nervoso.png": 390,
	"./sebastiao_saltitao": 391,
	"./sebastiao_saltitao.png": 391,
	"./sebastiao_sobre": 392,
	"./sebastiao_sobre.png": 392,
	"./sebastiao_triste": 393,
	"./sebastiao_triste.png": 393,
	"./sensacoes": 394,
	"./sensacoes.svg": 394,
	"./silhueta": 395,
	"./silhueta.svg": 395,
	"./team/AlziraAlbuquerque": 396,
	"./team/AlziraAlbuquerque.png": 396,
	"./team/AnaCarolinaGois": 397,
	"./team/AnaCarolinaGois.png": 397,
	"./team/AnaDiasFonseca": 398,
	"./team/AnaDiasFonseca.png": 398,
	"./team/AnaIsabelPereira": 399,
	"./team/AnaIsabelPereira.png": 399,
	"./team/AnaMariaPereira": 400,
	"./team/AnaMariaPereira.png": 400,
	"./team/BarbaraPereira": 401,
	"./team/BarbaraPereira.png": 401,
	"./team/BrigidaCaiado": 402,
	"./team/BrigidaCaiado.png": 402,
	"./team/BrunaPaulino": 403,
	"./team/BrunaPaulino.png": 403,
	"./team/CatarinaSantos": 404,
	"./team/CatarinaSantos.png": 404,
	"./team/DianaSantos": 405,
	"./team/DianaSantos.png": 405,
	"./team/HelenaMoreira": 406,
	"./team/HelenaMoreira.png": 406,
	"./team/JillEhrenreichMay": 407,
	"./team/JillEhrenreichMay.png": 407,
	"./team/JorgeOsmaLopez": 408,
	"./team/JorgeOsmaLopez.png": 408,
	"./team/MagdaRoberto": 409,
	"./team/MagdaRoberto.png": 409,
	"./team/MariaCristinaCanavarro": 410,
	"./team/MariaCristinaCanavarro.png": 410,
	"./team/MarianaSaraiva": 411,
	"./team/MarianaSaraiva.png": 411,
	"./team/VitoriaNunesVicente": 412,
	"./team/VitoriaNunesVicente.png": 412,
	"./trofeu": 413,
	"./trofeu.svg": 413,
	"./vantagens": 414,
	"./vantagens.svg": 414,
	"./vantagens_desvantagens": 415,
	"./vantagens_desvantagens.svg": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;